<template>
    <div>
        <div class="tabs is-boxed" v-show="files.length > 0">
            <ul>
                <li v-for="(file, index) in files" :key="index" @click="currentTab = index" :class="{ 'is-active': currentTab == index }">
                    <a>
                        <span class="icon is-small"><i class="fas fa-image" aria-hidden="true"></i></span>
                        <span>{{file.filename}}</span>
                        <button class="delete ml-2" @click="closed_tab = !closed_tab"></button>
                    </a>
                </li>
            </ul>
        </div>
        <div v-for="(file, index) in files" :key="index" v-show="currentTab == index ">
            <div class="notification is-info is-light" v-if="file.delimiter != ',' && !closed">
                <button class="delete" @click="closed = !closed"></button>
                Se actualizo cambio el delimitador <b>{{file.delimiter}}</b> por <b>,</b>
            </div>
            <div class="notification is-warning" v-show="file.bad_lines.count > 0 && !closed">
                <button class="delete" @click="closed = !closed"></button>
                ¡Atención! Se encontraron <b>{{file.bad_lines.count}}</b> lineas malformadas
            </div>
            <div class="notification is-warning" v-show="file.dup_lines.count > 0 && !closed">
                <button class="delete" @click="closed = !closed"></button>
                ¡Atención! Se encontraron <b>{{file.dup_lines.count}}</b> lineas duplicadas
            </div>
            <div class="notification is-warning" v-show="file.empty_columns.count > 0 && !closed">
                <button class="delete" @click="closed = !closed"></button>
                ¡Atención! Se encontraron <b>{{file.empty_columns.count}}</b> columns vacias
            </div>
            <div class="column" v-if="!file.auto_download">
                <a class="button is-info is-small" :href="file.url" :download="`fixed_${file.filename}`"><i class="mdi mdi-download-box"></i> Descargar</a>
            </div>
            <div class="table-container"  v-if="file.bad_lines.count > 0">
                <DataTable :data="file.bad_lines.lines" :options= "{pageLength: 100, destroy: true}" :buttons="['copy', 'excel', 'pdf']" class="display" width="100%">
                    <thead>
                        <tr>
                            <th v-for="(head, index) in file.bad_lines.head" :key="index">{{index == 0? "Linea": head}}</th>
                            <th v-for="index in file.bad_lines.lines[0].length - file.bad_lines.head.length" :key="index">Extra Column</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>
            <div class="table-container"  v-if="file.dup_lines.count > 0">
                <DataTable :data="file.dup_lines.lines" :options= "{pageLength: 100, destroy: true}" class="display">
                    <thead>
                        <tr>
                            <th v-for="(head, index) in file.dup_lines.head" :key="index">{{head}}</th>
                        </tr>
                    </thead>
                </DataTable>
            </div>
            <div class="table-container" v-show="file.empty_columns.count > 0">
                <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                    <thead>
                        <tr>
                            <th>Columna</th>
                            <th>Valor asignado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(column, index) in file.empty_columns.columns" :key="index">
                            <td>{{column.name}}</td>
                            <td>{{column.value}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import DataTable from 'datatables.net-vue3';
export default {
    name: "ExploredFiles",
    components:{
        DataTable
    },
    props:{
        files: Array
    },
    data(){
        return{
            currentTab: 0,
            closed: false,
            closed_tab: false
        }
    },
    methods:{
        
    }
}
</script>
<style>
    @import 'datatables.net-dt';
</style>